// extracted by mini-css-extract-plugin
export default {"userNameColumn":"UsersTab_userNameColumn__1Zms+","starIcon":"UsersTab_starIcon__r347B","selected":"UsersTab_selected__W9s1P","roleBadge":"UsersTab_roleBadge__cY4Fp"};